import { RouteObject } from "react-router";

const routes: RouteObject = {
    index: true,
    lazy: {
        Component: async () => (
            (await import('./Dashboard')).default
        ),
    },
};

export default routes;
